import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'pm-signature-pad',
  styleUrls: ['signature-pad.component.scss'],
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'signature-pad.component.html',
})
export class SignaturePadComponent implements AfterViewInit {
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  private signaturePad: SignaturePad;
  @Output() onResult: EventEmitter<string> = new EventEmitter<string>();

  public signaturePadOptions = {
    canvasWidth: 500,
    canvasHeight: 300,
  };
  readonly showCancelButton = true;
  readonly showContinueButton = true;
  readonly cancelButtonTitle = 'common_clear';
  readonly continueButtonTitle = 'common_continue';

  constructor() {}

  ngAfterViewInit(): void {
    // The canvas exists only after the view is created (constructor time => null => TypeError).
    this.signaturePad = new SignaturePad(this.canvas.nativeElement, {
      backgroundColor: 'rgba(255, 255, 255, 0)',
      penColor: 'rgb(0, 0, 0)'
    });
    this.clearPad();
  }

  clearPad() {
    this.signaturePad.clear();
  }

  getSignatureAndFinish() {
    this.onResult.emit(this.signaturePad.toDataURL());
  }
}
